import { render, staticRenderFns } from "./ActionMenuItem.vue?vue&type=template&id=44a752f1"
import script from "./ActionMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionMenuItem.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports